export async function fetchProductRecommendations(algolia, settings, signal) {
  const { appId, apiKey, indexName, defaultFilters = '' } = algolia || {}
  if (!settings?.enabled || !appId || !apiKey || !indexName) return []

  const productIds = (settings.productIds || []).map(id => String(id || '').trim()).filter(Boolean)
  const rules = (settings.rules || []).map(rule => String(rule || '').trim()).filter(Boolean)
  const filters = [String(settings.queryFilters || '').trim(), defaultFilters].filter(Boolean).join(' AND ')
  const fallbackFilters = String(settings.fallbackFilters || '').trim()
  const requests = (settings.type === 'trending-items' ? [null] : productIds).map(objectID => ({
    indexName,
    model: settings.type,
    threshold: Number(settings.threshold) || 0,
    maxRecommendations: 20,
    ...(objectID ? { objectID } : {}),
    queryParameters: {
      clickAnalytics: true,
      filters,
      ...(rules.length ? { ruleContexts: rules } : {}),
    },
    ...(fallbackFilters ? { fallbackParameters: { filters: fallbackFilters } } : {}),
  }))
  if (!requests.length) return []

  const response = await fetch(`https://${appId}.algolia.net/1/indexes/*/recommendations`, {
    method: 'POST',
    signal,
    headers: {
      'Content-Type': 'application/json',
      'x-algolia-api-key': apiKey,
      'x-algolia-application-id': appId,
    },
    body: JSON.stringify({ requests }),
  })
  if (!response.ok) return []

  const { results = [] } = await response.json()
  const products = []
  const excluded = new Set(settings.cartHandles || [])
  const max = Number(settings.max) || 4
  const length = Math.max(0, ...results.map(result => result.hits?.length || 0))
  for (let index = 0; index < length && products.length < max; index++) {
    for (const result of [...results].reverse()) {
      const hit = result.hits?.[index]
      if (!hit?.handle || excluded.has(hit.handle)) continue
      excluded.add(hit.handle)
      products.push({ ...hit, __indexName: indexName, __queryID: result.queryID, __position: products.length + 1 })
      if (products.length === max) break
    }
  }
  return products
}
